import _ from 'lodash';
import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Alert, Icon } from './';

// Import the CSS
import '../../scss/components/_pane.scss';

export default class Pane extends Component {
	handleClickClose (e) {
		e.preventDefault();

		this.close();
	}

	close () {
		this.props.onClose();
	}

	renderHeader () {
		return (
			<h5>
				<a href="#" onClick={ e => this.handleClickClose(e) }><Icon type="close" /></a>
				{ this.props.title }
			</h5>
		);
	}

	renderFooter () {
		return '';
	}

	render () {

		let pane;

		if (this.props.visible) {

			pane = (
				<div className="pane" key="pane">
					<div className="pane-container">

						{ this.renderHeader() }

						<If condition={ this.props.error && !this.props.error.errors }>
							<Alert className="pane-error" style="error">{ this.props.error.message }</Alert>
						</If>

						{ this.renderContent() }

						{ this.renderFooter() }

					</div>
				</div>
			);

		}

		return (
			<ReactCSSTransitionGroup
				component={ FirstChild }
				transitionName="pane"
				transitionEnterTimeout={500}
				transitionLeaveTimeout={500}>
				{ pane }
			</ReactCSSTransitionGroup>
		);
	}
}

/**
 * This component is passed in to the ReactCSSTransitionGroup so it does not
 * render the content within a <span> tag.
 */
class FirstChild extends Component {
	render () {

		let children = React.Children.toArray(this.props.children);

		return children[0] || null;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Pane.js